import { DependentDeviceFwUpdateInfo } from './dependent-device-fw-update-info.model';

export class LpcuFwUpdateInfo extends DependentDeviceFwUpdateInfo
{
    constructor(json: any = null)
    {
        super(json);
    }

}
